import type { AccentPalette } from "../types";

export const ACCENT_SOFT_PASTEL: AccentPalette = {
    label: "Soft Pastel",
    inflow: { base: "#79D8A8", selected: "#A4E5C4" },
    outflow: { base: "#EA9C90", selected: "#F2C2BA" },
    icons: {
        "ri-account-circle-line": { pillHex: "#F6E2DF", chartHex: "#E7A79D" },
        "ri-arrow-left-right-line": { pillHex: "#DFF6E9", chartHex: "#ADEBC7" },
        "ri-bank-card-line": { pillHex: "#EFDFF6", chartHex: "#CA8DE2" },
        "ri-bank-line": { pillHex: "#F6F6DF", chartHex: "#E6E79D" },
        "ri-bill-line": { pillHex: "#DFEFF6", chartHex: "#ADD8EB" },
        "ri-book-2-line": { pillHex: "#F6DFE9", chartHex: "#E28DB0" },
        "ri-bookmark-line": { pillHex: "#E2F6DF", chartHex: "#A6E79D" },
        "ri-box-3-line": { pillHex: "#E3DFF6", chartHex: "#B8ADEB" },
        "ri-briefcase-line": { pillHex: "#F6EADF", chartHex: "#E2B58D" },
        "ri-building-line": { pillHex: "#DFF6F0", chartHex: "#9DE7D5" },
        "ri-calculator-line": { pillHex: "#F6DFF5", chartHex: "#EBADE8" },
        "ri-car-line": { pillHex: "#EEF6DF", chartHex: "#C5E28D" },
        "ri-cash-line": { pillHex: "#DFE8F6", chartHex: "#9DB8E7" },
        "ri-coins-line": { pillHex: "#F6DFE1", chartHex: "#EBADB2" },
        "ri-computer-line": { pillHex: "#DFF6E4", chartHex: "#8DE29F" },
        "ri-exchange-dollar-line": { pillHex: "#EBDFF6", chartHex: "#C29DE7" },
        "ri-file-list-3-line": { pillHex: "#F6F1DF", chartHex: "#EBDEAD" },
        "ri-file-paper-2-line": { pillHex: "#DFF4F6", chartHex: "#8DDBE2" },
        "ri-funds-line": { pillHex: "#F6DFED", chartHex: "#E79DCA" },
        "ri-gift-line": { pillHex: "#E7F6DF", chartHex: "#C1EBAD" },
        "ri-government-line": { pillHex: "#DFE0F6", chartHex: "#8D90E2" },
        "ri-group-line": { pillHex: "#F6E5DF", chartHex: "#E7B09D" },
        "ri-hammer-line": { pillHex: "#DFF6EC", chartHex: "#ADEBCF" },
        "ri-hand-coin-line": { pillHex: "#F2DFF6", chartHex: "#D58DE2" },
        "ri-home-8-line": { pillHex: "#F3F6DF", chartHex: "#DDE79D" },
        "ri-landscape-line": { pillHex: "#DFECF6", chartHex: "#ADD1EB" },
        "ri-lightbulb-line": { pillHex: "#F6DFE6", chartHex: "#E28DA5" },
        "ri-line-chart-line": { pillHex: "#DFF6E0", chartHex: "#9DE79E" },
        "ri-macbook-line": { pillHex: "#E6DFF6", chartHex: "#C0ADEB" },
        "ri-megaphone-line": { pillHex: "#F6EDDF", chartHex: "#E2BF8D" },
        "ri-money-dollar-circle-line": { pillHex: "#DFF6F3", chartHex: "#9DE7DE" },
        "ri-percent-line": { pillHex: "#F6DFF2", chartHex: "#EBADE0" },
        "ri-pie-chart-2-line": { pillHex: "#EBF6DF", chartHex: "#BAE28D" },
        "ri-pie-chart-line": { pillHex: "#DFE5F6", chartHex: "#9DAFE7" },
        "ri-printer-line": { pillHex: "#F6E1DF", chartHex: "#EBB0AD" },
        "ri-question-line": { pillHex: "#DFF6E7", chartHex: "#8DE2AA" },
        "ri-receipt-line": { pillHex: "#EEDFF6", chartHex: "#CC9DE7" },
        "ri-safe-line": { pillHex: "#F6F4DF", chartHex: "#EBE6AD" },
        "ri-scales-3-line": { pillHex: "#DFF1F6", chartHex: "#8DD0E2" },
        "ri-settings-4-line": { pillHex: "#F6DFEA", chartHex: "#E79DC1" },
        "ri-shake-hands-line": { pillHex: "#E4F6DF", chartHex: "#BAEBAD" },
        "ri-shield-check-line": { pillHex: "#E1DFF6", chartHex: "#958DE2" },
        "ri-shopping-bag-3-line": { pillHex: "#F6E8DF", chartHex: "#E7B99D" },
        "ri-stock-line": { pillHex: "#DFF6EF", chartHex: "#ADEBD7" },
        "ri-store-2-line": { pillHex: "#F5DFF6", chartHex: "#E08DE2" },
        "ri-team-line": { pillHex: "#F0F6DF", chartHex: "#D4E79D" },
        "ri-time-line": { pillHex: "#DFE9F6", chartHex: "#ADC9EB" },
        "ri-timer-line": { pillHex: "#F6DFE3", chartHex: "#E28D9A" },
        "ri-tools-line": { pillHex: "#DFF6E2", chartHex: "#9DE7A7" },
        "ri-truck-line": { pillHex: "#E9DFF6", chartHex: "#C7ADEB" },
        "ri-umbrella-line": { pillHex: "#F6EFDF", chartHex: "#E2CA8D" },
        "ri-user-settings-line": { pillHex: "#DFF6F6", chartHex: "#9DE6E7" },
        "ri-wallet-line": { pillHex: "#F6DFEF", chartHex: "#EBADD8" },
    },
};
